<template>
  <span class="ai-visibility-impact-badge" :class="`ai-visibility-impact-badge--${normalizedImpact}`">
    <span class="badge-icon mdi" :class="`${badgeIconClass}`"></span>
      <span class="badge-label">{{ computedLabel }}</span>
  </span>
</template>

<script>
const LABELS = {
  high: 'High impact',
  medium: 'Medium impact',
  low: 'Low',
}

const ICONS = {
  high: 'mdi-circle-medium',
  medium: 'mdi-arrow-up',
  low: 'mdi-arrow-down',
}

export default {
  name: 'ImpactBadge',
  props: {
    impact: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    normalizedImpact() {
      return LABELS[this.impact] ? this.impact : 'low'
    },
    computedLabel() {
      return this.label || LABELS[this.normalizedImpact]
    },
    badgeIconClass() {
      return ICONS[this.normalizedImpact]
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-impact-badge {
  display: inline-flex;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
  padding: 4px 8px 4px 2px;

  h3 {
    font-size: 18px;
    font-weight: 700;
  }

  p {
    font-size: 14px;
    font-weight: 400;
  }
}

.ai-visibility-impact-badge--high {
  background: var(--v-red6Color-base);
  color: var(--v-red11Color-base);
}

.ai-visibility-impact-badge--medium {
  background: var(--v-lightYellowColor-base);
  color: var(--v-profileAnchorColor-base);
}

.ai-visibility-impact-badge--low {
  background: #F59E0B1A;
  color: #F59E0B;
  border: 1px solid #F59E0B;
}
</style>
